import { render, staticRenderFns } from "./DistributorIndex.vue?vue&type=template&id=aac42074"
import script from "./DistributorIndex.vue?vue&type=script&lang=js"
export * from "./DistributorIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports